<script setup lang="ts">
import {Question} from "@/Models/Question.ts";

const props = defineProps<{
    question: Question;
    response: {data: any; files?: {url: string}[]};
}>();

const categoryNames = (ids: string[]) => {
    return ids.map((id) => props.question.categories.find((category) => category.id === id)?.name ?? id).join(", ");
};
</script>
<template>
    <div class="pl--2 grow">
        <div v-if="question.is('voice')">
            <audio v-if="response.files?.[0]?.url" :src="response.files?.[0]?.url" controls class="w-full" />
        </div>
        <ul v-else-if="question.is('word') && question.params.allow_multiple" class="list-disc pl-6">
            <li v-for="A in response.data" class="">{{ A }}</li>
        </ul>
        <ol v-else-if="question.is('ranking')" class="list-decimal pl-6">
            <li v-for="A in response.data" class="mb-1">{{ question.option(A).value }}</li>
            <!--            <li v-for="A in response.data">{{ A }}</li>-->
        </ol>
        <table v-else-if="question.is('weighting')">
            <tr v-for="(value, id) in response.data">
                <th class="px-2 py-1 text-right align-top font-bold">{{ value }}</th>
                <td class="w-full py-1">{{ question.option(id).value }}</td>
            </tr>
        </table>
        <div v-else-if="question.is('slider') && question.params.slider_range">
            <div class="pl-10">
                <span class="font-bold">{{ response.data[0] }}</span>
                <span>-</span>
                <span class="font-bold">{{ response.data[1] }}</span>
            </div>
        </div>
        <div v-else-if="question.is('multiple_choice') && question.param('matrix')" class="max-w-full overflow-x-auto">
            <table class="min-w-max text-sm text-stone-700 dark:text-stone-200">
                <tbody>
                    <tr v-for="(categoryIds, optionId) in response.data" :key="optionId">
                        <th
                            scope="row"
                            class="whitespace-nowrap px-2 py-1 text-left align-middle font-bold text-stone-900 dark:text-stone-100"
                        >
                            {{ question.option(optionId)?.value }}
                        </th>
                        <td class="whitespace-nowrap px-2 py-1 align-middle text-stone-700 dark:text-stone-300">
                            {{ categoryNames(categoryIds) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ol v-else-if="Array.isArray(response.data)">
            <li v-for="(A, index) in response.data">{{ question.option(A).value }}</li>
        </ol>
        <div v-else-if="question.is('text')">
            <p>{{ response.data.content }}</p>
            <audio v-if="response.files?.[0]?.url" :src="response.files?.[0]?.url" controls class="mt-2 w-full" />
        </div>
        <div v-else-if="question.is('multiple_choice') || question.is('gatekeeper')">
            <h3 class="mb-2 font-medium">{{ question.option(response.data).value }}</h3>
            <img
                v-if="question.option(response.data).image"
                :src="question.option(response.data).image.url"
                :alt="question.option(response.data).value"
            />
        </div>
        <span v-else :class="{'pl-1 text-xl font-bold': question.is('slider')}">
            {{ response.data }}
        </span>
    </div>
</template>
<style scoped></style>
